<template>
<!--  <img alt="Vue logo" src="./assets/logo.png">-->
<!--  <HelloWorld msg="Welcome to Your Vue.js App"/>-->
  <el-menu
      default-active="/"
      class="el-menu-demo"
      mode="horizontal"
      text-color="#000"
      active-text-color="#9f0809"
      router
  >
<!--    <el-menu-item index="/">Advanced Search</el-menu-item>-->
    <el-menu-item index="/">Image Search</el-menu-item>
    <el-menu-item index="/api_v1">API Documentation</el-menu-item>
  </el-menu>
  <router-view />
</template>

<script>

export default {
  name: 'App',
  components: {

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.demo-tabs > .el-tabs__content {
  padding: 32px;
  color: #6b778c;
  font-size: 32px;
  font-weight: 600;
}

.el-tabs--right .el-tabs__content,
.el-tabs--left .el-tabs__content {
  height: 100%;
}
</style>
